<template>
    <nav class="navbar" :class="[bemFacets]">
        <navbar-content :items="items" :brand-logo-alt="brandLogoAlt"/>
    </nav>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';
    import NavbarContent from 'framework/components/navigation/navbar/navbar-content/navbar-content';

    export default {
        components: { NavbarContent },
        mixins: [bemMixin('navbar')],
        props: {
            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                required: true,
            },


            brandLogoAlt: {
                type: String,
                required: true,
            },
        },
    };
</script>
